import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MetaService } from '../../../meta.service';

@Component({
  selector: 'email-optout',
  templateUrl: './email-optout.component.html',
  styleUrls: ['../info.component.scss', './email-optout.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, RouterLink]
})
export default class EmailOptoutComponent {
  activated = inject(ActivatedRoute);
  
  email = signal<string>('placeholder@gmail.com');

  constructor() {

    const email = this.activated.snapshot.queryParams.email;
    if(email){
      this.email.set(email);
    }
  }

}
